/* ROUGHCUT build archive — shelves + viewer.
   ES5 only — Shopify's asset minifier on this theme targets es5 and refuses
   const/arrow/template syntax, then silently serves the file unminified.

   Two jobs:
     the shelves — one per pattern; the chips show or hide whole shelves
     the viewer  — tap-through one pattern's builds with a running timer

   The DOM is the only source of truth. The viewer holds no list of its own;
   it reads the tiles back out every time it opens, so the filter and the
   viewer can never disagree about what exists. */
(function () {
  var root = document.getElementById('rcPhotoWall');
  if (!root) return;

  /* The single #rcpwWall became one mosaic per shelf when this turned into
     an archive. Hold the shelves container instead — looking for the old id
     here silently killed the whole script. */
  var stack = document.getElementById('rcpwShelves');
  var view  = document.getElementById('rcpwView');
  if (!stack || !view) return;

  var tiles = [].slice.call(stack.querySelectorAll('.rc-pw__tile'));
  if (!tiles.length) return;

  var chips  = [].slice.call(document.querySelectorAll('.rc-pw__chip'));
  var shelves = [].slice.call(document.querySelectorAll('.rc-pw__shelf'));
  var count  = document.getElementById('rcpwCount');
  var pats   = document.getElementById('rcpwPatterns');

  var bars  = document.getElementById('rcpwBars');
  var img   = document.getElementById('rcpwImg');
  var ofTxt = document.getElementById('rcpwOf');
  var tag   = document.getElementById('rcpwTag');
  var tagIm = document.getElementById('rcpwTagImg');
  var tagNm = document.getElementById('rcpwTagName');
  var tagPr = document.getElementById('rcpwTagPrice');
  var cred  = document.getElementById('rcpwCredits');

  var META = {};
  try {
    META = JSON.parse(document.getElementById('rcpwMeta').textContent || '{}');
  } catch (e) { META = {}; }

  var HOLD = 4000;              /* ms a photo is held before advancing */
  var group = [];               /* tiles in the open group, in order */
  var at = -1;
  var timer = null;
  var held = false;

  /* ── the archive ──────────────────────────────────────────────────────
     A whole shelf goes at a time, not individual tiles. Out of the layout
     rather than merely invisible, or a filtered shelf leaves a gap and a
     stray divider line where its heading used to be. */
  function filter(handle, chip) {
    var i, photos = 0, groups = 0, on;
    for (i = 0; i < shelves.length; i++) {
      on = handle === 'all' || shelves[i].getAttribute('data-p') === handle;
      shelves[i].className = on ? 'rc-pw__shelf' : 'rc-pw__shelf is-hidden';
      if (on) {
        groups++;
        photos += shelves[i].querySelectorAll('.rc-pw__tile').length;
      }
    }
    for (i = 0; i < chips.length; i++) {
      chips[i].className = chips[i] === chip ? 'rc-pw__chip is-on' : 'rc-pw__chip';
    }
    if (count) count.textContent = photos;
    if (pats) pats.textContent = groups;

    /* The first shelf carries no top border. That has to follow the filter
       or a lone visible shelf keeps a rule floating above nothing. */
    var seen = false;
    for (i = 0; i < shelves.length; i++) {
      if (shelves[i].className.indexOf('is-hidden') > -1) continue;
      if (!seen) { shelves[i].className = 'rc-pw__shelf is-first'; seen = true; }
    }
  }

  for (var c = 0; c < chips.length; c++) {
    (function (chip) {
      chip.addEventListener('click', function () {
        filter(chip.getAttribute('data-p'), chip);
      });
    })(chips[c]);
  }

  /* ── the viewer ───────────────────────────────────────────────────── */
  function stop() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function paintBars() {
    if (!bars) return;
    var html = '', i;
    for (i = 0; i < group.length; i++) {
      html += '<i' + (i < at ? ' class="is-done"' : '') + '><b></b></i>';
    }
    bars.innerHTML = html;
  }

  function runBar() {
    if (!bars) return;
    var live = bars.children[at];
    if (!live) return;
    /* Force a reflow between setting width 0 and adding the class, or the
       browser coalesces both into one style change and the bar jumps
       straight to full instead of animating across. */
    live.className = '';
    var fill = live.firstChild;
    fill.style.width = '0';
    void live.offsetWidth;
    live.className = 'is-live';
  }

  function show(i) {
    if (i < 0) return;
    if (i >= group.length) { close(); return; }
    stop();
    at = i;

    var tile = group[i];
    var full = tile.getAttribute('data-full');
    var thumb = tile.querySelector('img');

    view.className = 'rc-pw__view is-loading';
    img.className = '';

    /* Show the thumbnail we already have while the big one arrives, so the
       screen is never blank between taps. */
    if (thumb && thumb.currentSrc) { img.src = thumb.currentSrc; img.className = 'is-in'; }

    var big = new Image();
    big.onload = function () {
      if (at !== i) return;                /* they tapped on already */
      img.src = full;
      img.className = 'is-in';
      view.className = 'rc-pw__view' + (held ? ' is-held' : '');
      paintBars();
      runBar();
      timer = setTimeout(function () { show(at + 1); }, HOLD);
    };
    big.onerror = function () {
      if (at !== i) return;
      view.className = 'rc-pw__view';
      paintBars(); runBar();
      timer = setTimeout(function () { show(at + 1); }, HOLD);
    };
    big.src = full;

    /* next two, quietly, so a tap forward is instant */
    for (var k = i + 1; k <= i + 2 && k < group.length; k++) {
      var pre = new Image(); pre.src = group[k].getAttribute('data-full');
    }

    var m = META[tile.getAttribute('data-p')];
    if (m && tag) {
      tag.href = m.u; tagNm.textContent = m.t; tagPr.textContent = m.p;
      if (m.i) { tagIm.src = m.i; tagIm.hidden = false; } else tagIm.hidden = true;
      tag.hidden = false;
    } else if (tag) tag.hidden = true;

    /* A photo added as a block knows exactly who made it, and that beats the
       pattern's group credit. Photos dropped in as a folder don't, so they
       fall back to it. Neither set means no line at all — an empty "Built by"
       is worse than none. */
    if (cred) {
      var who = tile.getAttribute('data-maker');
      if (!who && m && m.c) who = m.c;
      if (who) { cred.textContent = 'Built by ' + who; cred.hidden = false; }
      else cred.hidden = true;
    }

    if (ofTxt) ofTxt.textContent = (i + 1) + ' / ' + group.length;
  }

  function open(tile) {
    var handle = tile.getAttribute('data-p');
    /* Rebuilt from the DOM on every open, in wall order, so it always
       matches what is actually on screen — including after a filter. */
    group = [];
    for (var i = 0; i < tiles.length; i++) {
      if (tiles[i].getAttribute('data-p') === handle) group.push(tiles[i]);
    }
    var start = group.indexOf(tile);
    view.hidden = false;
    document.body.style.overflow = 'hidden';
    at = -1;
    show(start < 0 ? 0 : start);
  }

  function close() {
    stop();
    view.hidden = true;
    view.className = 'rc-pw__view';
    img.removeAttribute('src');       /* let go of a 1400px bitmap */
    document.body.style.overflow = '';
    at = -1;
    group = [];
  }

  for (var t = 0; t < tiles.length; t++) {
    (function (tile) {
      tile.addEventListener('click', function () { open(tile); });
    })(tiles[t]);
  }

  var prev = document.getElementById('rcpwPrev');
  var next = document.getElementById('rcpwNext');
  var xBtn = document.getElementById('rcpwX');
  if (prev) prev.addEventListener('click', function () { show(at - 1 < 0 ? 0 : at - 1); });
  if (next) next.addEventListener('click', function () { show(at + 1); });
  if (xBtn) xBtn.addEventListener('click', close);

  /* Press and hold to stop the timer — the single most-wanted thing in any
     story viewer, because the one photo you want to look at properly is
     always the one that advances. */
  function holdOn() {
    if (held) return;
    held = true;
    stop();
    view.className = 'rc-pw__view is-held';
    if (bars && bars.children[at]) {
      var live = bars.children[at];
      var w = live.firstChild.getBoundingClientRect().width;
      var full = live.getBoundingClientRect().width;
      live.className = '';
      live.firstChild.style.width = (full ? (w / full * 100) : 0) + '%';
    }
  }
  function holdOff() {
    if (!held) return;
    held = false;
    view.className = 'rc-pw__view';
    /* resume from where the bar actually got to, not from zero */
    if (bars && bars.children[at]) {
      var live = bars.children[at];
      var done = parseFloat(live.firstChild.style.width) || 0;
      var left = HOLD * (1 - done / 100);
      live.style.setProperty('--pw-dur', (left / 1000) + 's');
      live.className = 'is-live';
      live.firstChild.style.width = '100%';
      stop();
      timer = setTimeout(function () { show(at + 1); }, left);
    }
  }

  var frame = document.getElementById('rcpwFrame');
  if (frame) {
    frame.addEventListener('touchstart', function () { setTimeout(holdOn, 220); }, { passive: true });
    frame.addEventListener('touchend', holdOff);
    frame.addEventListener('touchcancel', holdOff);
    frame.addEventListener('mousedown', holdOn);
    frame.addEventListener('mouseup', holdOff);
    frame.addEventListener('mouseleave', holdOff);
  }

  document.addEventListener('keydown', function (e) {
    if (view.hidden) return;
    if (e.key === 'Escape') { close(); e.preventDefault(); }
    else if (e.key === 'ArrowRight' || e.key === ' ') { show(at + 1); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { show(at - 1 < 0 ? 0 : at - 1); e.preventDefault(); }
  });

  /* Swipe down to dismiss — the gesture people already try first. */
  var y0 = null;
  view.addEventListener('touchstart', function (e) {
    y0 = e.touches[0].clientY;
  }, { passive: true });
  view.addEventListener('touchend', function (e) {
    if (y0 === null) return;
    var dy = e.changedTouches[0].clientY - y0;
    y0 = null;
    if (dy > 90) close();
  });

  /* Leaving the tab shouldn't burn through somebody's photos unwatched. */
  document.addEventListener('visibilitychange', function () {
    if (view.hidden) return;
    if (document.hidden) holdOn(); else holdOff();
  });
})();
